"use strict"

import "../extend/date.js";
import { ModalEditClassRegister } from '../modals/modalEditClassRegister.js';
import { ClassGrouper}  from "../class-grouper.js";
import { ModalSelectDate } from "../modals/modalSelectDate.js";
import { ModalSelectTimeFrame } from "../modals/modalSelectTimeFrame.js";
import { ClassRegisterScroller } from "../classRegisterScroller.js";
import { ModalEditClassNote } from "../modals/modalEditClassNote.js";
import { ModalEditPupilNote } from "../modals/modalEditPupilNote.js";
import { ModalEditSmartphoneViolationNote } from "../modals/modalEditSmartphoneNote.js";
import { ModalEditReprimand } from "../modals/modalEditReprimand.js";
import { ModalEditDayAbsence } from "../modals/modalEditDayAbsence.js";
import { DayAbsence } from "../dayAbsence.js";
import { ModalMenu } from "../modals/modalMenu.js";
import { formatLink } from "../util.js";


export class ClassRegister {

   /**
    * Konstruktor
    * Wird einmal bei jedem Programmstart aufgerufen, noch bevor die Datenbank aufgebaut wurde.
    */  
   constructor(app) {
      this.app = app;
      this.dm = app.dm;

      this.tab = document.querySelector('.main-item[tab-name="class-register"]');
      this.elDate = this.tab.querySelector('.statusbar .date');

      this.elBtnPrevDay = this.tab.querySelector('.btn-prev-day');
      this.elBtnNextDay = this.tab.querySelector('.btn-next-day');
      this.elInfo = this.tab.querySelector('.info');

      this.elBtnPrevDay.onclick = () => {
         this.scroller.scroll(1);
      }

      this.elBtnNextDay.onclick = () => {
         this.scroller.scroll(-1);         
      }

      this.elClassContainer = this.tab.querySelector('.view-select .classes .my-classes');

      this.tab.querySelector('.open-class-list').onclick = () => {
         this.tab.querySelector('.class-list').classList.toggle('opened');
      }

      this.scroller = new ClassRegisterScroller({}, this);
      this.scroller.currentDate = new Date();
      this.tab.appendChild(this.scroller.getElement());

      this.tab.querySelector('.view-select .btn-my').classList.add('selected');

      this.tab.querySelector('.view-select .btn-my').onclick = (event) => {
         event.stopPropagation();
         this.selector = { type: 'teacher' };
         this.timetable = this.dm.getTimetableByTeacher(this.user.id);
         this.deleteNotOwnClasses();
         this.tab.querySelectorAll('.view-select .class.selected').forEach(element => element.classList.remove('selected'));
         event.target.classList.add('selected');
         this.scroller.setCurrentDate(this.scroller.currentDate);
      }

      this.elDate.onclick = (event) => {
         event.stopPropagation();
         let ed = new ModalSelectDate({ range: false, onSelect: (date) => this.scroller.setCurrentDate(date) });
         ed.setDate(this.scroller.currentDate);
      }

      this.tab.querySelector('.statusbar .today').onclick = (event) => {
         event.stopPropagation();
         this.scroller.setCurrentDate(new Date());
      }


   }

   /**
    *  Initialisierung
    *  Wird einmal beim Programmstart aufgerufen (nachdem die Datenbank initialisiert wurde)
    *  und immer wenn sich der Datenbestand grundlegend geändert haben könnte (Update, komplettes DB-Update etc.)
    */
   init() {

      this.user = this.dm.getUserSelf();
      this.classGrouper = new ClassGrouper(Object.values(this.dm.getCurrentYear().classes));

      if (this.user.type === 'teacher') {
         this.selector =  { type: 'teacher', teacherId: this.user.id };
         let myClasses = this.loadMyClasses();
         this.loadClassList(myClasses);
         //this.timetable = this.dm.getTimetableByTeacher(this.user.id);
      }
      else {
         //this.timetable = this.dm.getTimetableByPupil(this.user.id);
         this.selector =  { type: 'class', classId: this.user.classId };
      }

      this.tab.querySelector('.view-select').style.display = this.user.type === 'teacher' ? 'flex' : 'none';

   }


   load(loadData) {

      if (this.user.type === 'teacher') {
         this.timetable = this.dm.getTimetableByTeacher(this.user.id);
      }
      else {
         this.timetable = this.dm.getTimetableByPupil(this.user.id);
      }

      if (!loadData) return;
      this.scroller.setCurrentDate(this.scroller.currentDate);
      this.tab.setAttribute('loaded', true);

   }

   redrawBuffer() {
      this.scroller.redrawBuffer();
   }

   initDay(element) {
     element.classList.add('day');
   }

   async loadClassNotes(element, isoDate, items) {

      try {
         if (this.user.hasPermission('classreg', 'edit')) {
            //element.querySelector('.notes .btn.icon-plus').onclick = 
            element.querySelector('.notes').onclick = (event) => {
               const note = { classes: [ this.selector.classId ], dateFrom: isoDate, dateTo: isoDate, creatorId: this.user.id };
               event.stopPropagation();
               const btnPos = element.querySelector('.notes .btn.icon-plus').getBoundingClientRect();

               new ModalMenu({
                  items: [
                     { label: 'Klassenbuch-Anmerkung', onSelect: () => new ModalEditClassNote(this.app, note) },
                     { label: 'Schüler-Anmerkung', onSelect: () => new ModalEditPupilNote(this.app, note, () => this.redrawBuffer()) },
                     { label: '📱 Handy-Verstoß', onSelect: () => new ModalEditSmartphoneViolationNote(this.app, note, () => this.redrawBuffer()) },
                     { label: '⚠️ Tadel', onSelect: () => new ModalEditReprimand(this.app, note, () => this.redrawBuffer()) },
                  ],
                  position: { corner: 'top right', offset: { x: document.body.getBoundingClientRect().right - btnPos.left, y: btnPos.top } }
               });
            };
            document.body.addEventListener('click', () => element.querySelector('.notes .dropdown-content').classList.remove('show'));
         }

         const elItems = element.querySelector('.notes .items');

         for (let item of items) {

            try {

               let note = formatLink(item.note);

               let elItem = null;
               if (item.type === 'classNote') {
                  let classes = {};
                  for (const cl of item.classes) classes[cl] = cl;
                  elItem = elItems.createElement('div', 'class-note-item');
                  elItem.innerHTML = '<div class="content"><span class="classes">' + this.classGrouper.group(classes) + '</span><span class="message">' + note + '</span>'
                                 + '<span class="creator">' + this.dm.getUser(item.creatorId).short + '</span></div>';
               }
               else if (item.type === 'pupilNote' || item.type === 'smartphoneViolation' || item.type === 'reprimand') {
                  const pupil = this.user.type === 'teacher' ? this.app.dm.getUser(item.pupilId) : this.user;
                  const icons = { 'smartphoneViolation': '📱', 'reprimand': '⚠️'};
                  const icon = item.type in icons ? icons[item.type] : '';
                  elItem = elItems.createElement('div', 'class-note-item');
                  elItem.innerHTML = '<div class="content">' + icon + '<span class="pupil">' + pupil.lastName + ', ' + pupil.firstName + '</span> ' +' <span class="message">' + note + '</span>'
                                   + '<span class="creator">' + this.dm.getUser(item.creatorId).short + '</span></div>';
               }

               if (item.syncStatus === 'delete') elItem.classList.add('deleted');

               if (this.user.hasPermission('classreg', 'edit')) {
                  elItem.onclick = (event) => {
                     if      (item.type === 'classNote') new ModalEditClassNote(this.app, item);
                     else if (item.type === 'pupilNote') new ModalEditPupilNote(this.app, item, () => this.redrawBuffer());
                     else if (item.type === 'smartphoneViolation') new ModalEditSmartphoneViolationNote(this.app, item, () => this.redrawBuffer());
                     else if (item.type === 'reprimand') new ModalEditReprimand(this.app, item, () => this.redrawBuffer());
                     event.stopPropagation();
                  }
                  elItem.querySelectorAll('a').forEach(elA => elA.onclick = (e) => {
                     e.stopPropagation();
                  });   
               }

               ClassRegister.createSyncStatus(elItem, item, this.user.id);
            }
            catch (e) {
               logger.error(e);
               toast.alert("Eine Klassennotiz konnte nicht geladen werden: " + e, { duration: 8000 });
            }            

         }

      }
      catch(e) {
         toast.alert(e, { duration: 8000 });
         logger.error(e);
      }

   }

   async loadAbsences(element, isoDate, absences) {

      if (this.user.hasPermission('absences', 'edit')) {
         element.querySelector('.absences').onclick = (event) => {
            new ModalEditDayAbsence(this.app, { dateFrom: isoDate, dateTo: isoDate, classId: this.selector.classId });
         };
      }

      for (let absData of absences) {
         try {
            if (absData.dateFrom <= isoDate && absData.dateTo >= isoDate) {
               let dayAbsence = new DayAbsence(this.app, this.user, absData);

               let elAbs = HTMLElement.createFromHTML(`
                  <span class="absence ${dayAbsence.getCssClasses()}" data-id="${dayAbsence.data.id}">
                     <span class="avatar">${dayAbsence.getIcon()}</span> 
                     ${dayAbsence.pupil.lastName}, ${dayAbsence.pupil.firstName} ${dayAbsence.getNotes(isoDate)}
                  </span>
               `);

               if (this.user.hasPermission('absences', 'edit')) {
                  elAbs.onclick = async (event) => {
                     try {
                        event.stopPropagation();
                        const abs = await this.dm.getDayAbsence(parseInt(event.target.dataset.id));
                        new ModalEditDayAbsence(this.app, abs);
                     }
                     catch(e) {
                        toast.alert(e, { duration: 8000 });
                        logger.error(e);
                     }
                  };
               }
               element.querySelector('.absences .items').appendChild(elAbs);
            }
         }
         catch (e) {
            logger.error(e);
            toast.alert("Ein fehlender Schüler konnte nicht geladen werden: " + e, { duration: 8000 });
         }
      }
   }
   
   async loadDay(element, isoDate) {

      try {      
         //element.querySelectorAll('.table').forEach(table =>table.remove());
         if (this.selector.type === 'teacher') {
            element.innerHTML = '<div class="info" style="display: none"></div><div class="table"></div>';
            let items = this.user.type === 'teacher'
               ? await this.dm.getClassRegisterItems({ creatorId: this.user.id, date: isoDate })
               : await this.dm.getClassRegisterItems({ date: isoDate });
            this.loadClassRegister(element, isoDate, items);
         }
         else {
            element.innerHTML = `
               <div class="info" style="display: none"></div>
               <div class="absences"><i class="icon-user-times"></i><div class="items"></div><i class="btn icon-plus"></i></div>
               <div class="notes"><i class="icon-edit"></i><div class="items"></div>
                  <div class="dropdown">
                     <i class="btn icon-plus"></i>
                     <div class="dropdown-content">
                        <div class="menu">
                           <div class="button btn-new-general">Allgemeine Notiz</div>
                           <div class="button btn-new-pupil">Schülerbezogene Notiz</div>
                        </div>
                     </div>
                  </div>
               </div>
               <div class="table"></div>
               <div class="class-info">
                  <div class="header">Klassen-Informationen</div>
                  <div class="buttons">
                     <div class="flat-button btn-edit">bearbeiten</div>
                     <div class="flat-button btn-save">speichern</div>
                     <div class="flat-button btn-cancel">abbrechen</div>
                  </div>
                  <div class="info"></div>
               </div>
            `;
            if (!this.user.hasPermission('classreg', 'edit')) element.querySelector('.notes .icon-plus').style.display = 'none';
            if (!this.user.hasPermission('absences', 'edit')) element.querySelector('.absences .icon-plus').style.display = 'none';

            this.dm.getClassRegisterDayData(isoDate, this.selector.classId).then(dayData => {
               if (!dayData || dayData.fromCache) {
                  const lastUpdate = dayData ? ` (Stand: ${new Date(dayData.time).format("%d.%m.%Y %H:%i:%s Uhr")})` : '';
                  element.querySelector('.info').innerHTML = `Ohne Internetverbindung werden nur Daten angezeigt, die auf diesem Gerät zwischengespeichert wurden${lastUpdate}.`;
                  element.querySelector('.info').style.display = 'block';
               }
               this.loadClassNotes(element, isoDate, dayData ? dayData.classNotes : [])
               this.loadAbsences(element, isoDate, dayData ? dayData.dayAbsences : []);
               this.loadClassRegister(element, isoDate, dayData ? dayData.classRegister : []);
               this.loadClassInfo(element, this.selector.classId);
            });
         }
      }
      catch(e) {
         console.error(e);
         toast.alert(e, { duration: 8000 });
      }
   }

   async loadClassInfo(element, classId) {



      const elInfo = element.querySelector('.class-info');

      if (this.user.type !== 'teacher') {
         elInfo.style.display = 'none';
         return;
      }

      const summernoteSettings = {
         focus: true,
         tabsize: 2,
         height: 120,
         toolbar: [
           ['style', ['style']],
           ['font', ['bold', 'underline', 'clear']],
           ['color', ['color']],
           ['para', ['ul', 'ol', 'paragraph']],
           ['table', ['table']],
           ['insert', ['link', 'picture', 'video']],
           ['view', ['fullscreen', 'codeview', 'help']]
         ]
      }

      const $txtNote = $('.class-info .info', element);
      const cls = this.dm.getClass(classId);

      const editable = !!(cls.formTeachers.includes(this.user.id) | this.user.hasPermission('classes', 'edit-all'));
      element.querySelector('.class-info .buttons').style.display = editable ? 'block' : 'none';

      $txtNote[0].innerHTML = cls.info;

      const toggleButtons = function(mode='view') {
         element.querySelector('.class-info .btn-save').style.display = mode === 'view' ? 'none' : 'inline-block';
         element.querySelector('.class-info .btn-cancel').style.display = mode === 'view' ? 'none' : 'inline-block';
         element.querySelector('.class-info .btn-edit').style.display = mode !== 'view' ? 'none' : 'inline-block';
      }

      toggleButtons('view');

      element.querySelector('.class-info .btn-edit').onclick = () => {
         $txtNote.summernote(summernoteSettings);
         toggleButtons('edit');
      }

      element.querySelector('.class-info .btn-cancel').onclick = () => {
         $txtNote.summernote('destroy');
         $txtNote[0].innerHTML = cls.info;         
         toggleButtons('view');
      }


      element.querySelector('.class-info .btn-save').onclick = () => {
         const info = $txtNote.summernote('code');
         toggleButtons('view');
         $txtNote.summernote('destroy');

         cls.info = $txtNote.summernote('code');
         this.dm.sinRequest({
            action: 'cls-save-info',
            classId: cls.id,
            info:    cls.info
         });
         this.redrawBuffer();
      }

      element.appendChild(elInfo);

   }

   async loadClassRegister(element, isoDate, items) {

      const elTable = element.querySelector('.table');

      /*
      let timeFrames = [
         { start: '',      end: ''},
         { start: '8:05',  end: '8:50' },
         { start: '8:50',  end: '9:35' },
         { start: '9:50',  end: '10:35' },
         { start: '10:40', end: '11:25' },
         { start: '11:35', end: '12:20' },
         { start: '12:25', end: '13:10' }
      ];

      let timeFramesPM = [
         { start: '13:35', end: '14:20' },
         { start: '14:20', end: '15:05' },
         { start: '15:05', end: '15:50' },
         { start: '15:50', end: '16:35' }
      ];
      */

      const tf = this.dm.getTimeFrames('regular');
      const timeFrames = [{}, ...tf.am];

      if (this.user.type === 'pupil' && this.user.class.year < 11) {
         this.timeFrames = timeFrames.concat([], [tf.sek1_7]);
      }
      else {
         this.timeFrames = timeFrames.concat([], tf.pm);
      }

      this.head = ['', 'Fach', 'Eintrag'];
      
      for (let i=0; i<this.head.length; ++i) {
         const elHead = elTable.createElement('div', 'cell head');
         elHead.style.gridArea = `1 / ${i+1}`;
         elHead.innerHTML = this.head[i];
      }

      items.sort((a,b) => {
         if (a.hour.from != b.hour.from) return a.hour.from - b.hour.from;
         return a.hour.to - b.hour.to;
      });

      await this.loadClassRegisterItems(elTable, items, new Date(Date.fromString(isoDate)));

      if (this.user.type === 'teacher') {
         elTable.querySelectorAll('.cell.subject, .cell.main, .cell.empty').forEach(item => item.onclick = async (event) => {
            event.stopPropagation();
            let el = event.currentTarget;
            this.editItem(el.getData('classRegisterItem'), el.getData('timetableItem'), isoDate, el.getData('hour'));
         });
      }

   }

   async loadClassRegisterItems(elTable, items, date) {

      let currentRow = 2;
      let currentHour = 1;

      if (!this.timetable) return;

      const dayTimetable = this.timetable.filter(item => item.weekday === date.getWeekday()+1);
     
      for (let item of items) {

         // eigene Einträge durch die aus der Datenbank ersetzen
         if (item.id && item.creatorId === this.user.id) {
            const dbItem = await this.dm.getClassRegisterItem({ id: item.id });
            if (dbItem) item = dbItem;
         }

         // leere Einträge vor diesem Eintrag anlegen
         for (let hour=currentHour; hour<item.hour.from; ++hour) {
            const progress = this.createEmptyField(elTable, hour, currentRow, dayTimetable);
            currentRow += progress;
            currentHour += progress;
         }

         // Den eigentlichen Klassenbucheintrag anlegen
         this.createClassRecord(elTable, item, currentRow);

         // Die Stundentitel für diesen Klassenbucheintrag anlegen
         for (let hour=item.hour.from; hour<=item.hour.to; ++hour) {
            this.createHourTitle(elTable, hour, currentRow, item);            
            currentRow++;
         }

         currentHour = item.hour.to + 1;

      }
     
      // die restlichen leeren Felder bis zur 12. Stunde anlegen
      for (let hour = currentHour; hour <= 12; ++hour) {
         //this.createHourTitle(elTable, hour, currentRow);
         const progress = this.createEmptyField(elTable, hour, currentRow, dayTimetable);
         currentRow += progress;
         currentHour += progress;
      }

   }

   createClassRecord(elTable, item, currentRow) {

      try {

         const elSubject = elTable.createElement('div', 'cell subject');
         elSubject.dataset.classRegisterId = item.localId;
         elSubject.dataset.classRegisterExtId = item.id;

         elSubject.style.gridArea = `${currentRow} / 2 / span ${item.hour.to - (item.hour.from-1)} / span 1`;
         let creator = this.dm.getUser(item.creatorId);
         elSubject.innerHTML = '<span class="class">' + this.getStudyGroupTitle(item.studyGroupType, item.studyGroups) + '</span> <span>' + item.title + '</span> <span class="creator">' +  (creator ? creator.short : '?') + '</span>';

         const elMain = elTable.createElement('div', 'cell main');
         elMain.setData('classRegisterItem', item);
         elMain.style.gridArea = `${currentRow} / 3 / span ${item.hour.to - (item.hour.from-1)} / span 1`;
         if (item.syncStatus === 'delete') {
            elMain.classList.add('deleted');
            elSubject.classList.add('deleted');
         }
         if (item.permission.includes('PUPILS_OF_COURSE')) {
            elMain.createElement('div', 'permission-pupils-tag');
         }
         else if (item.permission.includes('PUPILS_ABSENT')) {
            elMain.createElement('div', 'permission-pupils-tag absent-only');
         }
         if (item.permission.includes('TEACHERS_ALL')) {
            elMain.createElement('div', 'permission-teachers-tag');
         }
         else if (item.permission.includes('TEACHERS_OF_CLASS')) {
            elMain.createElement('div', 'permission-teachers-tag of-class');
         }

         const elContent = elMain.createElement('div', 'main-item content');
         elContent.innerHTML = formatLink(item.content.replaceAll('\n', '<br>'));

         if (item.homework && item.homework.length) {
            const elHomework = elMain.createElement('div', 'main-item');
            elHomework.innerHTML = '<div class="icon"><i class="icon-home"></i></div><div class="content">' + formatLink(item.homework.replaceAll('\n', '<br>')) + '</div>  ';
         }

         let hourSpan = (item.hour.to - item.hour.from) + 1;

         const absentPupils = item.absent ? item.absent.filter(item => item.type === 'pupil') : false;
         if (absentPupils && absentPupils.length) {
            const elAbsent = elMain.createElement('div', 'main-item');
            elAbsent.innerHTML = '<div class="icon"><i class="icon-user-times"></i></div><div class="content">' + absentPupils.map(item => {
               if (this.user.type === 'pupil') {
                  if (this.user.id === item.id) {
                     return '<span class="absent '+ (item.justified ? 'justified' : 'not-justified') +'">'
                     + '<span class="last-name">' + this.user.lastName + '</span>, <span class="first-name">' + this.user.firstName + '</span>'
                     + (item.value !== hourSpan ? (': ' + item.value) : '')
                     + (item.note ? ' (' + item.note + ')' : '') + '</span>';
                  }
                  else {
                     console.log(item.id, "Fehler!!!");
                  }
               }
               else {
                  let pupil = this.dm.getPupil(item.id);
                  return '<span class="absent '+ (item.justified ? 'justified' : 'not-justified') +'">'
                        + '<span class="last-name">' + pupil.lastName + '</span>, <span class="first-name">' + pupil.firstName + '</span>'
                        + (item.value !== hourSpan ? (': ' + item.value) : '')
                        + (item.note ? ' (' + item.note + ')' : '') + '</span>';
               }
            }).sort().join(' ') + '</div>';
            
         }

         const absentHomework = item.absent ? item.absent.filter(item => item.type === 'homework') : false;
         if (absentHomework && absentHomework.length) {
            const elAbsent = elMain.createElement('div', 'main-item absent-homework');
            elAbsent.innerHTML = '<div class="icon"><i class="icon-home"></i></div><div class="content">' + absentHomework.map(item => {
               if (this.user.type === 'pupil') {
                  if (this.user.id === item.id) {
                     return `<span class="absent-homework">${item.value === 1 ? '' : '½ '}<span class="last-name">${this.user.lastName}</span>, <span class="first-name">${this.user.firstName}</span>`;
                  }
                  else {
                     console.log(item.id, "Fehler!!!");
                  }
               }
               else {
                  let pupil = this.dm.getPupil(item.id);
                  return `<span class="absent-homework">${item.value === 1 ? '' : '½ '}<span class="last-name">${pupil.lastName}</span>, <span class="first-name">${pupil.firstName}</span></span>`;
               }
            }).sort().join(' ') + '</div>';
            
         }

         const absentMaterial = item.absent ? item.absent.filter(item => item.type === 'material') : false;
         if (absentMaterial && absentMaterial.length) {
            const elAbsent = elMain.createElement('div', 'main-item absent-material');
            elAbsent.innerHTML = '<div class="icon"><i class="icon-docs-1"></i></div><div class="content">' + absentMaterial.map(item => {
               if (this.user.type === 'pupil') {
                  if (this.user.id === item.id) {
                     return `<span class="absent-material">${item.value === 1 ? '' : '½ '}<span class="last-name">${this.user.lastName}</span>, <span class="first-name">${this.user.firstName}</span>`;
                  }
                  else {
                     console.log(item.id, "Fehler!!!");
                  }
               }
               else {
                  let pupil = this.dm.getPupil(item.id);
                  return `<span class="absent-material">${item.value === 1 ? '' : '½ '}<span class="last-name">${pupil.lastName}</span>, <span class="first-name">${pupil.firstName}</span></span>`;
               }
            }).sort().join(' ') + '</div>';
            
         }

         if (item.notes && item.notes.length) {
            const elNotes = elMain.createElement('div', 'main-item');
            elNotes.innerHTML = '<div class="icon"><i class="icon-pencil"></i></div><div class="content">' + formatLink(item.notes) + '</div>';
         }

         if (item.attachment && item.attachment.length) {
            const elAttachment = elMain.createElement('div', 'main-item');
            elAttachment.innerHTML = '<div class="icon"><i class="icon-attach"></i></div><div class="content">' + item.attachment.map(attach => {
               return '<a href="'+this.app.server+'?action=file-download&ref=' + attach.id + ':class-register:' + item.id + '&auth-token=' + localStorage.getItem('authToken') + '" target="_blank"><span class="attachment">' + attach.name + '</span></a>'
            }).sort().join(' ') + '</div>';
            elAttachment.querySelectorAll('a').forEach(item => item.addEventListener('click', e => e.stopPropagation()));
         }


         if (item.creatorId === this.user.id) {
            elSubject.classList.add('my');
            elMain.classList.add('my');
         }

         elMain.querySelectorAll('.auto-link').forEach(el => el.onclick = (e) => e.stopPropagation());

         ClassRegister.createSyncStatus(elMain, item, this.user.id);
      }
      catch (e) {
         logger.error(e);
         toast.alert("Ein Klassenbucheintrag konnte nicht geladen werden: " + e, { duration: 8000 });
      }

   }

   createHourTitle(elTable, hour, row) {

      const elHour = elTable.createElement('div', 'cell hour-name');
      elHour.style.gridArea = `${row} / 1`;
      elHour.innerHTML = this.timeFrames[hour] ? `<div class="timeframe">${this.timeFrames[hour].start}</div><div class="hour">${hour}</div><div class="timeframe">${this.timeFrames[hour].end}</div>` : hour;
      elHour.onclick = () => {
         new ModalSelectTimeFrame("Unterrichtszeiten auswählen", (type) => {
            this.dm.setTimeFrameType(type);
            this.redrawBuffer();
         });
      };

      return elHour;

   }

   createEmptyField(elTable, hour, row, timetable) {

      const ttItems = timetable.filter(item => item.displayHour === hour || hour.between(item.displayHour, (item.displayHour+item.displaySpan)-1));
      let progress = 0;

      if (ttItems.length === 0) ttItems.push(false);

      for (let ttItem of ttItems) {

         this.createHourTitle(elTable, hour, row);

         const elSubject = elTable.createElement('div', 'cell subject empty');
         elSubject.setData('timetableItem', ttItem);
         elSubject.setData('hour', hour);
         elSubject.style.gridArea = `${row} / ${2}`;

         const elMain = elTable.createElement('div', 'cell empty');
         elMain.setData('timetableItem', ttItem);
         elMain.setData('hour', hour);
         elMain.style.gridArea = `${row} / ${3}`;

         if (ttItem) {
            elSubject.innerHTML = '<span class="class">' + (ttItem.course ? ttItem.course.classNames : '') + '</span> <span>' + ttItem.title + '</span> <span class="creator">' +  ttItem.teachers.map(id => this.dm.getUser(id).short).join(',') + '</span>';
         }
         progress++;
         row++;
      }

      return progress;

      /*
      if (ttItems.length) {
         const title = ttItems.map(item => item.title).join('/');
         //const teacher = ttItems.map.teachers.map(id => this.dm.getUser(id).short).join(',')
         elSubject.innerHTML = '<span>' + title + '</span> <span class="creator">' +  'x' + '</span>';
      }
      */

   }

   async editItem(item, timetableItem, isoDate, hour) {

      try {
         if (item) {
            if (typeof item.date === 'string') item.date = new Date(Date.fromString(item.date));
            new ModalEditClassRegister(this.app, item);
         }
         else {
            // Abwesende Schüler der Klasse ermitteln
            let absences = [];

            if (timetableItem && timetableItem.course) {
               for (let classId of timetableItem.course.classes) {
                  let cls = this.dm.getClass(classId);
                  if (cls.year >= 11) {
                     let abs = [];
                     try {
                        abs = (await this.dm.getDayAbsences({ classId: classId, date: isoDate })).filter(abs => abs.absenceType !== 'late');
                        for (let a of abs) {
                           if (a.dateFrom <= isoDate && a.dateTo >= isoDate) {
                              if (!absences.find(item => item.id === a.pupilId)) {
                                 absences.push({
                                    type: 'pupil',
                                    id:         a.pupilId,
                                    justified:  a.absenceType === 'school' ? true : a.justified,
                                    note:       a.note,
                                    value:      a.absenceType === 'school' ? 0 : timetableItem.span
                                 });
                              }
                           }
                        }
                     }
                     catch (e) {
                        console.error(e);
                     }

                  }
               }
            }

            new ModalEditClassRegister(this.app, {
               creatorId: this.user.id,
               date: this.scroller.currentDate,
               hour: timetableItem ? { from: timetableItem.hour, to: timetableItem.hour + (timetableItem.span -1) } : { from: hour, to: hour },
               studyGroupType: 'course',
               studyGroups: [timetableItem.courseId],
               title: timetableItem.title,
               absent: absences,
               saveOnlineOnly: false,
               new: true
            });
         }
      }
      catch(e) {
         toast.alert(e, { duration: 8000 });
         logger.error(e);
      }

   }

   getStudyGroupTitle(type, groups) {

      if (type === 'course') {

         const classNames = [];
         for (let courseId of groups) {
            const course = this.dm.getCourse(courseId);
            if (course) classNames.push(course.classNames);
         }

         return classNames.unique().join(',');
      }
      else {
         let classes = {};
         for (let cl of groups) classes[cl] = cl;
         return this.classGrouper.group(classes).join(',');
      }

   }

   static createSyncStatus(element, item, userId) {

      const elSyncStatus = element.createElement('div', 'sync-status');
      if (item.creatorId === userId) {
         if (item.syncStatus === '') {
            elSyncStatus.innerHTML = '<i class="icon-check"></i>'
            elSyncStatus.classList.add('ok');
         }           
         else if (item.syncStatus === 'update') {
            elSyncStatus.innerHTML = '<i class="icon-refresh"></i>'
            elSyncStatus.classList.add('update');
         }
      }
      if (item.syncStatus === 'error') {
         elSyncStatus.innerHTML = '!'
         elSyncStatus.classList.add('error');
      }

   }

   loadMyClasses() {

      let myClasses = [];
      this.dm.getMyCourses().map(course => myClasses = myClasses.concat(course.classes).unique());
      
      this.elClassContainer.empty();

      let classes = myClasses.map(id => this.dm.getClass(id));
      classes.sort((a,b) => {
         if (a.year !== b.year) return a.year - b.year;
         if (a.ext < b.ext) return -1;
         if (a.ext > b.ext) return 1;
         return 0;
      });

      classes.map(cls => this.addClass(cls));

      if (!this.elClassContainer.querySelector('.selected')) this.selector = { type: 'teacher', teacherId: this.user.id };

      return myClasses;

   }

   deleteNotOwnClasses() {
      this.elClassContainer.querySelectorAll('.not-my').forEach(el => el.remove());
   }

   addClass(cls, my=true) {

      if (!my) this.deleteNotOwnClasses();

      let elClass = this.elClassContainer.createElement('div', 'class');
      if (!my) elClass.classList.add('not-my');

      elClass.innerHTML = cls.name;
      elClass.dataset.classId = cls.id;

      if (this.selector === 'class' && this.selector.classId === cls.id) {
         elClass.classList.add('selected');
      }
      
      elClass.onclick = (event) => {
         if (my) this.deleteNotOwnClasses();
         event.stopPropagation();
         this.tab.querySelectorAll('.view-select .class.selected, .view-select .btn-my.selected').forEach(element => element.classList.remove('selected'));
         event.target.classList.add('selected');
         let classId = parseInt(event.target.dataset.classId);
         this.selector = { type: 'class', classId: classId };
         if (cls.year < 11) this.timetable = this.dm.getTimetableByClass(classId);
         else this.timetable = [];
         
         this.scroller.setCurrentDate(this.scroller.currentDate);
      };

      return elClass;

   }

   loadClassList(myClasses) {
      const classes = Object.values(this.dm.getClasses()).filter(cls => !myClasses.includes(cls.id) && cls.year !== 0).sort((a,b) => {
         if (a.year !== b.year) return a.year - b.year;
         return a.ext.localeCompare(b.ext);
      });

      const elClassList = this.tab.querySelector('.class-list');
      elClassList.empty();

      let year = 0;
      let elRow = null;
      for (const cls of classes) {
         if (cls.year !== year) {
            elRow = elClassList.createElement('div', 'year-row');
            year = cls.year;
         }
         
         let elClass = elRow.createElement('div', 'class');
         elClass.innerHTML = cls.name;
         elClass.dataset.classId = cls.id;
         
         elClass.onclick = (event) => {
            if (this.dm.online) {
               elClassList.classList.remove('opened');
               event.stopPropagation();
               const elClass = this.addClass(cls, false);
               elClass.click();
            }
            else {
               toast.alert("Diese Funktion ist nur mit Internetverbindung verfügbar.", { duration: 8000 });
            }
         };

      }

   }



};
